import axiosClient from "../../../utils/axios";
import { ApiResponse } from "../../../types/api.types";

export interface CoachDashboardStats {
  totalActiveUsers: number;
  totalDepartments: number;
  totalTeams: number;
}

export interface CoachTeamFromApi {
  id: number;
  name: string;
  department: { id: number; name: string; organization_id: number };
  created_at: string;
  team_lead: { id: number; name: string; email: string } | null;
}

export interface TeamsListResponse {
  rows: CoachTeamFromApi[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasMore: boolean;
}

export interface TeamSurveyMember {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  nick_name: string;
  image: string | null;
  completed_per: number;
}

export interface TeamSurveyData {
  id: number;
  name: string;
  department: { id: number; name: string; organization_id: number };
  team_compl_percentage: number;
  team_lead: {
    id: number;
    name: string;
    nick_name: string;
    image: string | null;
    email: string;
    completed_per: number;
  } | null;
  members: TeamSurveyMember[];
}

export const getCoachDashboardStats = async (organization_id: number) => {
  try {
    const response = await axiosClient.post<ApiResponse<CoachDashboardStats>>(
      "/dashboard",
      { organization_id },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching coach dashboard stats:", err);
    throw err;
  }
};

export const getCoachTeamsList = async (
  organization_id: number,
  page = 1,
  limit = 100,
) => {
  try {
    const response = await axiosClient.post<ApiResponse<TeamsListResponse>>(
      "/teams/list",
      { organization_id, page, limit },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching coach teams list:", err);
    throw err;
  }
};

export const getTeamSurveyData = async (
  team_id: number,
  questionnaire_id: number,
) => {
  try {
    const response = await axiosClient.post<ApiResponse<TeamSurveyData>>(
      "/teams/survey",
      { team_id, questionnaire_id },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching team survey data:", err);
    throw err;
  }
};
